import { h, Component } from 'preact';
import { Form, Validators, validateField } from '../utils/form-helpers';
import modalContent from '../constants/modalContent';
import FieldWrapper from './generics/FieldWrapper';
import ButtonWrapper from './generics/ButtonWrapper';
import AlertMessage from './generics/AlertMessage';
import emitEvent from '../utils/emitEvent';

const field = {
  EMAIL: 'email',
};

export default class ForgotPinContent extends Component {
  constructor () {
    super();
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      isLoading: false,
      error: '',
      form: new Form({
        [field.EMAIL]: {
          value: '',
          validators: [Validators.required(), Validators.email()],
        },
      }),
    };
  }

  componentDidMount () {
    const { form } = this.state;
    form.clearValues(this);
  }

  onSubmit () {
    const { form } = this.state;
    const { onChangeContent, session, mixpanelTracker } = this.props;
    const email = form.getValue(field.EMAIL).toLowerCase();
    this.setState({ isLoading: true, error: '' });

    session
      .forgotPin(email)
      .then(() => {
        onChangeContent(modalContent.EMAIL_SENT);
        mixpanelTracker.trackForgotPassword(email);
        this.setState({ isLoading: false });
        emitEvent('forgotPin', null);
      })
      .catch((reason) => {
        mixpanelTracker.trackForgotPassword(email);
        this.setState({
          isLoading: false,
          error: 'Un error inesperado ha ocurrido',
        });
        emitEvent('forgotPin', reason);
      });
  }

  render () {
    const { form, isLoading, error } = this.state;
    const emailIsInvalid = form.fieldHasErrors(field.EMAIL);
    return (
      <form onSubmit={form.onSubmit(this, this.onSubmit)} noValidate>
        <AlertMessage visible={Boolean(error)} type="error">
          {error}
        </AlertMessage>
        <FieldWrapper
          hasError={emailIsInvalid}
          className="form-item"
          errorLegend="Por favor escriba un correo electrónico valido"
        >
          <input
            type="email"
            name={field.EMAIL}
            placeholder="Correo electrónico"
            onInput={validateField(this, form)}
          />
        </FieldWrapper>
        <div>
          <ButtonWrapper type="submit" className="w-modal-button" isLoading={isLoading}>
            Envíar correo
          </ButtonWrapper>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./components/ForgotPinContent.js